export const getHeaderData = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/botbdynamiccontent/getheaderdata`, {
    credentials: "include",
  });

export const snoozePastDueBanner = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/SnoozeSubscriptionPastDueBanner`, {
    method: "POST",
    credentials: "include",
  });

export const snoozeSubscriptionCancelationBanner = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/SnoozeSubscriptionCancelationBanner`, {
    method: "POST",
    credentials: "include",
  });

export const getCartData = async (validateCart: boolean) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/CartGet?validateCart=${validateCart}`);

export const removeUnplayedTickets = async (cartItemId: number, quantityToRemove: number) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/removeunplayedtickets?cartItemId=${cartItemId}&quantityToRemove=${quantityToRemove}`,
    {
      method: "POST",
      body: JSON.stringify({ cartItemId, quantityToRemove }),
    }
  );

export const removeCartItem = async (cartItemId: number) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/RemoveProduct?cartItemId=${cartItemId}`);

export const removeCompetitionEntry = async (ticketId: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/RemoveTicketFromTicketIdString?ticketId=${ticketId}`);

export const addProductInCart = async (sku: string, addToCartMethodId: number) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/AddProduct?sku=${sku}&addToCartMethodId=${addToCartMethodId}`
  );

export const getCartTotal = async () => await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/GetCartTotal`);

export const getUserLoyaltyAssociatedCars = async (apiString: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/${apiString}`);

export const playFreeTicketsLater = async (cartItemId: number, playNow: boolean) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/playfreeticketlater?cartItemId=${cartItemId}&playLater=${playNow}`,
    {
      method: "POST",
    }
  );

export const addFreeTicket = async (contentNodeId: number) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/choosefreeticket?contentNodeId=${contentNodeId}`);

export const getValidationDetails = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/validation/getvalidationdetails`);

export const getNotifications = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/storednotification/getusernotifications`);

export const markNotificationAsViewed = async (notificationIds: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/storednotification/markasviewed?ids=${notificationIds}`, {
    method: "POST",
  });

export const markNotificationAsClicked = async (notificationIds: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/storednotification/markasclicked?ids=${notificationIds}`, {
    method: "POST",
  });
